export default __webpack_public_path__ + "static/review-1-76a35519d348e6d015af27d05324fee6.png";